import { Carousel } from '@fastcampus/browser-util';

const DEFAULT_DELAY = 4000;
const WIDTH_OF_2SLIDES = 500;
const WIDTH_OF_3SLIDES = 333;

const carouselOptions = {
  'fc-layout-211': {
    loop: false,
    autoplay: false,
  },
  'fc-layout-212': {
    loop: 'infinite',
    responsive: [
      {
        breakpoint: 959,
        option: {},
      },
      {
        breakpoint: 559,
        option: {},
      },
    ],
  },
  'fc-layout-213': {
    loop: false,
    autoplay: false,
    slidesToShow: 3,
    slidesToScroll: 3,
  },
  'fc-layout-214': {
    loop: 'infinite',
    delay: 3000,
    duration: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  },
  'fc-layout-215': {
    slidesToShow: 4,
    slidesToScroll: 4,
    pager: true,
  },
};

class LayoutCarousel extends Carousel {
  constructor(props) {
    super(props);
  }

  initCarouselStyle(slidePosition, previewPosition = 1, duration = this.duration, ease = this.ease) {
    const previewWidth = (Math.floor((1 - this.ratioToPreview) * 100) / 2) * previewPosition;

    if (this.responsive.length && this.loop) {
      const width = 1 / this.slidesToShow * this.ratioToPreview * 100;
      const currentIndex = slidePosition / width;
      const tabletEachWidth = this.slidesToShow === 3 ? WIDTH_OF_3SLIDES : WIDTH_OF_2SLIDES;

      const slideTransition = this.currentBreakpoint === 559
        ? `translate3d(calc(75% * ${-currentIndex} - (20px * ${currentIndex})), 0, 0)`
        : `translate3d(${-currentIndex * tabletEachWidth}px, 0, 0)`;

      if (this.currentBreakpoint) {
        this.carousel.setAttribute(
          'style',
          `
          visibility: visible;
          display: flex;
          align-items: flex-start;
          transform: translate3d(${previewWidth}%, 0, 0) ${slideTransition};
          transition-duration: ${duration / 1000 + 's'};
          transition-timing-function: ${ease};
          `
        );

        return true;
      }
    }

    super.initCarouselStyle(slidePosition, previewWidth, duration, ease);
  }

  handleDraggable() {
    if (this.loop) {
      super.handleDraggable();
    }
  }
}

const shuffleElement = (slides, i) => {
  const shuffledChildren = _.shuffle(slides[i].children);

  [...shuffledChildren].forEach(item => {
    slides[i].appendChild(item);
  });
};

const getCarouselOption = (columnCount, autoplay, delay) => {
  return {
    className: 'carousel',
    pause: false,
    pager: false,
    slidesToShow: parseInt(columnCount),
    slidesToScroll: parseInt(columnCount),
    autoplay: autoplay === 'true',
    delay: delay,
  };
};

export const multipleCarousel = (w, d, rootElem) => {
  [...d.querySelectorAll(`.${rootElem}`)].forEach(($layout, layoutIndex) => {
    const className = 'carousel__cards';
    const slides = $layout.querySelectorAll(`.${className}`);

    slides.forEach((item, i) => {
      const {
        dataset: {
          columnCount,
          delay = DEFAULT_DELAY,
          shuffle,
          autoplay,
        },
      } = item;

      if (shuffle === 'true') {
        shuffleElement(slides, i);
      }

      const optionByCarousel = Object.assign({}, getCarouselOption(columnCount, autoplay, delay), carouselOptions[rootElem]);
      const totalOption = optionByCarousel ? Object.assign(optionByCarousel, { selector: item }) : { selector: item };

      new LayoutCarousel(totalOption);
    });
  });
};